
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import ServiceCard from "../Cards/ServiceCard";
import { GET_SERVICES } from "../../Utils/Queries";
import { Box, Typography, Grid } from "@mui/material";
import { Masonry } from "@mui/lab";
import ServiceCardMansory from "../Cards/ServiceCardMansonry";
import CardLoader from "../Cards/CardLoader";

const ServiceListings = () => {
  const { loading, data: listings, error } = useQuery(GET_SERVICES);

  const services =
    listings?.listAllAvailableServicesWithoutAuthentication?.items;

  return (
    <>
      <Box
        sx={{
          boxShadow:
            " rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          borderRadius: "5px",
          p: 2,
          pb: 3,
          my: 5,
          bgcolor: " #f2f2f2",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: {
              lg: "24px",
              xs: "16px",
              md: "24px",
              sm: "18px",
            },
            fontWeight: 700,
          }}
        >
          Our Service Listings
        </Typography>

        {loading ? (
          <CardLoader />
        ) : (
          <Masonry
            defaultColumns={{ lg: 6, sm: 4, xs: 2 }}
            defaultHeight={450}
            columns={{ lg: 6, sm: 4, xs: 2 }}
            spacing={2}
            sx={{ mt: 2, width: "100%", mx: 0 }}
          >
            {services?.length < 1 ? (
              <p>No Data</p>
            ) : (
              services?.map((service, index) => (
                <Link key={index} to={`/service-view/${service._id}`}>
                  <ServiceCardMansory
                    image={service.images}
                    title={service.title}
                    price={service.price.toLocaleString()}
                    description={service.description}
                  />
                </Link>
              ))
            )}
          </Masonry>
        )}
      </Box>
    </>
  );
};

export default ServiceListings;
